import React from "react";
import { Gem, Handshake, PenTool } from "lucide-react";

const pillars = [
  {
    title: "Bespoke by Design",
    description:
      "No templates. No shortcuts. Every engagement begins from a blank page and ends with something that could belong to no one else.",
    Icon: PenTool,
  },
  {
    title: "White-Glove Partnership",
    description:
      "You work directly with the artisans building your product — a private, attentive relationship from first sketch to final launch.",
    Icon: Handshake,
  },
  {
    title: "Enduring Quality",
    description:
      "We build for the long term: fast, resilient, and finished to a standard that still feels considered years from now.",
    Icon: Gem,
  },
];

const Ethos = () => {
  return (
    <section id="ethos" className="border-y border-white/5 bg-onyx/50">
      <div className="mx-auto max-w-6xl px-6 py-20 sm:py-28 lg:py-36">
        <p className="text-xs font-light tracking-luxe uppercase text-gold">
          The Ethos
        </p>
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-medium leading-tight sm:text-5xl">
          Crafted as if it were our own.
        </h2>
        <div className="mt-12 grid gap-10 sm:mt-16 sm:grid-cols-3 sm:gap-14">
          {pillars.map(({ title, description, Icon }) => (
            <div key={title}>
              <Icon size={26} strokeWidth={1.25} className="text-gold" />
              <h3 className="mt-6 font-display text-xl font-medium text-ivory">
                {title}
              </h3>
              <div className="mt-4 h-px w-10 bg-gold/40" />
              <p className="mt-4 text-sm font-light leading-relaxed text-stone">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ethos;
